import axios from "axios";

// Initialize Firebase
class Messaging {
  constructor() {
    if (!("PushManager" in window)) {
      // Push isn't supported on this browser, disable or hide UI.
      return;
    }
    var config = {
      apiKey: "AIzaSyDWxSbQ9s6GQ4Sc8p_mmX_rwkIkrnGd0rA",
      authDomain: "simplestrengths-bd387.firebaseapp.com",
      projectId: "simplestrengths-bd387",
      storageBucket: "simplestrengths-bd387.appspot.com",
      messagingSenderId: "4937986823"
    };
    window.firebase.initializeApp(config);
    this.messaging = window.firebase.messaging();
    // not all browsers support the api's firebase messaging need
    if (Notification && Notification.permission === "denied") {
      // Skip messaging
    } else {
      // Add the public key generated from the console here.
      this.messaging.usePublicVapidKey(
        "BJj5uylFDvXvlNNAQmXfCSfSNLxFKg0HJF_D4V9jZtM0Hyfo3YtWBH4YSZDMOUITUdJVW0_AIpU1VxHBwA5lpxw"
      );
    }
    this.messaging.onTokenRefresh(() => this.retrieveToken());
  }

  sendLocal(title, text, image) {
    new Notification(title, { body: text, icon: image });
  }
  retrieveToken() {
    if (!("PushManager" in window)) {
      // Push isn't supported on this browser, disable or hide UI.
      return;
    }
    this.messaging
      .getToken()
      .then(function(currentToken) {
        if (currentToken) {
          axios.post(`${process.env.VUE_APP_API_URL}devices/`, {
            type: "web",
            registration_id: currentToken
          });
        }
      })
      .catch(() => {
        // Unable to retrieve token
      });
  }

  requestPermission() {
    if (!("PushManager" in window)) {
      // Push isn't supported on this browser, disable or hide UI.
      return;
    }
    return this.messaging.requestPermission().catch(() => {
      // permission denied or otherwise not given
    });
  }
}
let messaging = {};
try {
  messaging = new Messaging();
} catch (e) {
  messaging = {
    messaging: {
      userServiceWork() {}
    },
    requestPermission() {}
  };
}

export default messaging;
